import { useState } from 'react';
import { useHistory } from 'react-router';
import Auth from '@aws-amplify/auth';
import {
  AuthPanel,
  ChangePasswordForm,
  ChangePasswordFormValues,
  ForgotPasswordForm,
  ForgotPasswordFormValues,
  useToastNotifications,
} from '@nbirl/nbi-common-ui-libs';
import { FormikHelpers } from 'formik';

import { PATHS } from '../../shared/constants';
import { useErrorToast } from '../../shared/hooks';

export const ForgotPassword = () => {
  const { addToast } = useToastNotifications();
  const history = useHistory();
  const [isForgotPasswordFormPending, setIsForgotPasswordFormPending] =
    useState(false);
  const [isChangePasswordFormPending, setIsChangePasswordFormPending] =
    useState(false);
  const [email, setEmail] = useState<string>();
  const { showErrorToast } = useErrorToast();

  const handleBackButtonOrSuccess = () => history.push(PATHS.LogIn);

  const handleForgotPasswordFormSubmit = async (
    values: ForgotPasswordFormValues
  ) => {
    try {
      setIsForgotPasswordFormPending(true);
      await Auth.forgotPassword(values.email);
      setEmail(values.email);
    } catch (error: any) {
      setIsForgotPasswordFormPending(false);
      showErrorToast(error);
    }
  };

  const handleChangePasswordFormSubmit = async (
    username: string,
    { code, newPassword }: ChangePasswordFormValues,
    formikHelpers: FormikHelpers<ChangePasswordFormValues>
  ) => {
    try {
      setIsChangePasswordFormPending(true);
      await Auth.forgotPasswordSubmit(username, code, newPassword);

      addToast({
        variant: 'success',
        text: 'Password changed.',
      });
      handleBackButtonOrSuccess();
    } catch (error: any) {
      setIsChangePasswordFormPending(false);

      if (error?.code === 'InvalidPasswordException') {
        formikHelpers.setFieldError('newPassword', error.message);
      } else {
        showErrorToast(error);
      }
    }
  };

  return (
    <AuthPanel>
      {email ? (
        <ChangePasswordForm
          email={email}
          isPending={isChangePasswordFormPending}
          showCodeField={true}
          helpText={
            'We have sent a password reset code by sms. Enter it below to reset your password.'
          }
          onSubmit={(values, formikHelpers) =>
            handleChangePasswordFormSubmit(email, values, formikHelpers)
          }
          showBackButton
          onBack={handleBackButtonOrSuccess}
        />
      ) : (
        <ForgotPasswordForm
          isPending={isForgotPasswordFormPending}
          onSubmit={handleForgotPasswordFormSubmit}
          onBackButton={handleBackButtonOrSuccess}
        />
      )}
    </AuthPanel>
  );
};
